/* List of ribbon colors and their color codes */
var colorJSON = {
  White: "#fcfcfc",
  Ivory: "#fefef7",
  "Dark Ivory": "#eee8cd",
  Beige: "#dac4a5",
  Taupe: "#d4cdc3",
  Nude: "#e4cfba",
  Biscotti: "#cab6ac",
  Champagne: "#d0bea5",
  Stone: "#cdcdb4",
  "Light Brown": "#a69898",
  Portabello: "#806c6d",
  Brown: "#594b4c",
  Truffle: "#473336",
  Cream: "#FEFEF0",
  "Desert Coral": "#B78278",
  Apple: "#981c41",
  Wine: "#692640",
  Valentina: "#ef1128",
  Mulberry: "#9a375a",
  Cabernet: "#5c2c35",
  Burgundy: "#8b1427",
  Red: "#c00017",
  Rust: "#b53c2d",
  Scarlet: "#ce181b",
  Maroon: "#4a0509",
  Merlot: "#4e0215",
  "Desert Rose": "#905655",
  "Canyon Rose": "#874456",
  Aubergine: "#44192C",
  Orange: "#ff5722",
  Persimmons: "#e23e21",
  Sienna: "#d94514",
  "Burnt Orange": "#c75500",
  Tangerine: "#fd9850",
  "Autumn Orange": "#c14616",
  Pumpkin: "#f87116",
  Terracotta: "#D17964",
  "Coral Reef": "#f48788",
  Guava: "#f05364",
  Sunset: "#dc8b86",
  Watermelon: "#fa7a79",
  "Blush Pink": "#e0cbc8",
  "Petal Pink": "#f9dfd5",
  Ballet: "#eaadad",
  Tickled: "#f9c3d0",
  Quartz: "#b29297",
  "Rose Petal": "#faeeea",
  "Candy pink": "#ffd4e7",
  "Hot Pink": "#d80d86",
  Fucshia: "#e236a4",
  Chianti: "#ab5568",
  "Rose Gold": "#cca49e",
  "Dusty Rose": "#e1bbb8",
  Azalea: "#ac0a6b",
  Magenta: "#de1e8f",
  "Victorian Rose": "#883f52",
  Cassis: "#cb5cb8",
  "Rose Quartz": "#f3d6da",
  "Pale Blush": "#f5dddb",
  Mauve: "#c9a5ad",
  "Dark Mauve": "#C4B3B4",
  "Dusty Mauve": "#DAC5C4",
  "Rosy Mauve": "#ad7784",
  "Vintage Rose": "#F9EFE6",
  "Pearl Pink": "#FCDBD4",
  Flamingo: "#FCA4AE",
  "Barely Pink": "#E8D0CC",
  Sedona: "#BD7169",
  Peach: "#f5ba9e",
  Bellini: "#fbbea7",
  Papaya: "#fa9178",
  "Soft Peach": "#f5d7c3",
  Daffodil: "#ffffcd",
  Lemon: "#fef984",
  Marigold: "#fec559",
  Gold: "#ddb766",
  Canary: "#ffeba8",
  Sunflower: "#fada0c",
  Mustard: "#deac27",
  "Pale Yellow": "#f6efba",
  Mint: "#c3e5da",
  Meadow: "#98b5a1",
  "Dusty Sage": "#c9d9cf",
  Juniper: "#205241",
  Forest: "#394e4d",
  Olive: "#778151",
  Clover: "#5d9468",
  Agave: "#95a6a0",
  Moss: "#4e722d",
  Emerald: "#057d40",
  Jungle: "#00908b",
  "Dark Green": "#0a574d",
  "Hunter Green": "#09413e",
  Celedon: "#96c1b0",
  Sage: "#698f7a",
  "Pine Green": "#244d1e",
  "Lime Green": "#31c731",
  "Bright Green": "#47cf14",
  "Light Teal": "#c8e8ee",
  Spa: "#80cecc",
  Pool: "#60e0f9",
  Turquoise: "#5eebff",
  Malibu: "#00b2d1",
  Oasis: "#00839b",
  Peacock: "#035d69",
  Jade: "#0BAAB0",
  "Steel Blue": "#809dbd",
  "Ink Blue": "#174c78",
  Stormy: "#9fa1b3",
  "Dusty Blue": "#8c9dad",
  Twilight: "#506175",
  Navy: "#1e2c5b",
  Neptune: "#2c3f50",
  Royal: "#212eb1",
  "Blue Jay": "#5388cd",
  Ocean: "#2478ec",
  Carribean: "#91dce8",
  Sky: "#cbeafe",
  Mist: "#d5e7f5",
  "Ice Blue": "#92b1d7",
  Horizon: "#004b99",
  Marine: "#0d3862",
  Cobalt: "#1c3061",
  Capri: "#ccddfa",
  "Island Blue": "#01bbe7",
  "Baby Blue": "#d9ebff",
  "Vintage Mauve": "#cfb1b5",
  Dusk: "#ccbdca",
  Fog: "#abaec4",
  Iris: "#d8cfe7",
  "Lavender Haze": "#b69bb5",
  Wisteria: "#906c8d",
  Regency: "#472f92",
  Plum: "#470040",
  Amethyst: "#42264f",
  Tahiti: "#9e81b6",
  Orchid: "#961d78",
  Grape: "#561f58",
  "Dusty Lavender": "#999eb2",
  Purple: "#633295",
  "Light Purple": "#ba00f7",
  Lavender: "#d6dcfe",
  Lilac: "#e6cbf8",
  Sangria: "#710c4c",
  Raspberry: "#862a77",
  Periwinkle: "#c5dafe",
  Mystic: "#909a9c",
  Mercury: "#7a7d7b",
  Pewter: "#595c68",
  Graphite: "#525252",
  Black: "#000000",
  Charcoal: "#645f64",
  Sterling: "#9fa4ab",
  Gray: "#ccc4c3",
  Silver: "#cfd1cc",
  Steelgray: "#6f7478",
  Dolphin: "#969da3",
  Frost: "#ebebe7",
  "Dove Grey": "#D6D1CF",
  "Gold Sparkle": "#f4a467",
  "Silver Sparkle": "#dfd9d9",
  "Sage Green": "#b8c4ae",
  "Bright Coral": "#ed353e",
  Sand: "#e5bca1",
  "Light Blue": "#e5f1ff",
  "Just Like The Picture": "transparent",
  "No Ribbons": "transparent",
  "Choose Color 1": "gray",
  "Choose Color 2": "gray",
  "Choose Color 3": "gray",
  "Choose Color 4": "gray",
  "Choose Color ": "gray",
  "Black Halo": "#241528",
  "Black Glitter": "#241528",
  "Chocolate Brown": "#452200",
  Burlap: "#a4845e",
  "Ballet Pink": "#d7a6a2",
  "Rose Gold Glitter": "#e6bcb0",
  "Purple Glitter": "#63028f",
  "Purple Tip": "#63028f",
  "Purple Halo": "#63028f",
  "Dark Purple": "#301934",
  Mermaid: "#301934",
  Pink: "#ffc0ca",
  "Pink Halo": "#ffc0ca",
  "Light Pink": "#FFB6C1",
  "Azalea/Begonia": "#e3047f",
  "Hot Pink Glitter": "#a70253",
  "Lavender Tip": "#dcd0fe",
  "Lavender Glitter": "#dcd0fe",
  "Plum Halo": "#40003f",
  "Plum/Purple": "#40003f",
  "Capri Blue": "#d6e3f3",
  "Tiffany Blue": "#ccf9ff",
  Teal: "#ccf9ff",
  "Turquoise Glitter": "#74e0fc",
  "Turquoise Tip": "#74e0fc",
  "Malibu Blue": "#28b3d4",
  "Malibu Halo": "#28b3d4",
  "Oasis Blue": "#097c95",
  "Pool Blue": "#83cbde",
  "Light Blue": "#e5f1ff",
  "Royal Blue": "#0352b5",
  "Royal Blue Glitter": "#0352b5",
  "Royal Halo": "#0352b5",
  "Navy Blue": "#002b73",
  "Horizon Blue": "#0226b0",
  "Marine Blue": "#001a45",
  "Clover Green": "#3d9d21",
  "Mint Green": "#c4fbdc",
  "Emerald Green": "#0f6c2b",
  Green: "#0f6c2b",
  Coral: "#f26a5a",
  "Red Glitter": "#da0200",
  Cranberry: "#560d1d",
  "Lemon Yellow": "#ffffac",
  Yellow: "#ffffac",
  "Bright Yellow": "#fef200",
  "Mustard Yellow": "#c28e14",
  "Mercury Gray": "#626164",
  "Gold Glitter": "#b59d41",
  "Silver Glitter": "#aaaada",
  "Apple Red": "#900d2c",
  "Deep Red": "#7e050c",
  "Dark Peach": "#fea788",
  "Cream Cheese": "#fffdd0",
  "Dusty Peach": "#f9b89c",
  "Pink Champagne": "#ffc0bf",
  Fuchsia: "#e73b8f",
};

var colormap = new Map(Object.entries(colorJSON));

$(document).ready(function () {
  /* IE 9/10/Edge warning and DPO support */
  if (
    /MSIE 10/i.test(navigator.userAgent) ||
    /IE 9/i.test(navigator.userAgent) ||
    /rv:11.0/i.test(navigator.userAgent) ||
    /Edge\/\d./i.test(navigator.userAgent)
  ) {
    if (document.cookie.indexOf("alert-box=") == -1) {
      $(".shopify-section")
        .eq(1)
        .prepend(
          '<div id="browseralert" class="alert alert-danger alert-dismissible fade show" role="alert"><strong>Heads up!</strong> You should use a modern browser to view this site.<button type="button" onclick="document.cookie = \'alert-box=Closed\';" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button></div>'
        );
    }
    var updatePriceInterval = setInterval(function () {
      if (window.dpoOptions) {
        window.dpoOptions.updatePrice();
      } else {
        clearInterval(updatePriceInterval);
      }
    }, 1000);
  }

  /* Sticky header: handled by draft-only CSS in layout/theme.liquid. */

  /* Add clickable table rows */
  $("tr[data-href]").on("click", function () {
    window.location = $(this).data("href");
  });

  /* Fix the live chat not showing "We're online" etc. because of not being minimized. */
  var autoMinimize = setInterval(function () {
    if ($(".zsiq_floatmain").length != 0) {
      if ($ZSIQWidgetUI != undefined) {
        $ZSIQWidgetUI.minimizeSticker();
        clearInterval(autoMinimize);
      }
    }
  }, 1000);

  /* Toggle toolips */
  //if(!isMobileDevice()) {
  $('*[data-toggle="tooltip"]').tooltip({ trigger: "hover" });
  //}
});

/* Checks if we have touch enabled */
function isMobileDevice() {
  return (
    "ontouchstart" in window ||
    (window.DocumentTouch && document instanceof DocumentTouch)
  );
}

/* Count business days from a certain date, used for shipping expectation */
function businessDaysFromDate(date, businessDays) {
  var counter = 0,
    tmp = new Date(date);
  while (businessDays >= 0) {
    tmp.setTime(date.getTime() + counter * 86400000);
    if (isBusinessDay(tmp)) {
      --businessDays;
    }
    ++counter;
  }
  return tmp;
}

/* Checks if a day is a business day and checks for holidays */
function isBusinessDay(date) {
  var dayOfWeek = date.getDay();
  if (dayOfWeek === 0 || dayOfWeek === 6) {
    // Weekend
    return false;
  }

  holidays = [
    "12/31+5", // New Year's Day on a saturday celebrated on previous friday
    "1/1", // New Year's Day
    "1/2+1", // New Year's Day on a sunday celebrated on next monday
    "1-3/1", // Birthday of Martin Luther King, third Monday in January
    "2-3/1", // Washington's Birthday, third Monday in February
    "5~1/1", // Memorial Day, last Monday in May
    "7/3+5", // Independence Day
    "7/4", // Independence Day
    "7/5+1", // Independence Day
    "9-1/1", // Labor Day, first Monday in September
    "10-2/1", // Columbus Day, second Monday in October
    "11/10+5", // Veterans Day
    "11/11", // Veterans Day
    "11/12+1", // Veterans Day
    "11-4/4", // Thanksgiving Day, fourth Thursday in November
    "12/24+5", // Christmas Day
    "12/25", // Christmas Day
    "12/26+1", // Christmas Day
  ];

  var dayOfMonth = date.getDate(),
    month = date.getMonth() + 1,
    monthDay = month + "/" + dayOfMonth;

  if (holidays.indexOf(monthDay) > -1) {
    return false;
  }

  var monthDayDay = monthDay + "+" + dayOfWeek;
  if (holidays.indexOf(monthDayDay) > -1) {
    return false;
  }
  var weekOfMonth = Math.ceil((dayOfMonth - 1) / 7);
  monthWeekDay = month + "-" + weekOfMonth + "/" + dayOfWeek;
  if (holidays.indexOf(monthWeekDay) > -1) {
    return false;
  }

  var lastDayOfMonth = new Date(date);
  lastDayOfMonth.setMonth(lastDayOfMonth.getMonth() + 1);
  lastDayOfMonth.setDate(0);
  var negWeekOfMonth =
      Math.floor((lastDayOfMonth.getDate() - dayOfMonth - 1) / 7) + 1,
    monthNegWeekDay = month + "~" + negWeekOfMonth + "/" + dayOfWeek;
  if (holidays.indexOf(monthNegWeekDay) > -1) {
    return false;
  }

  return true;
}
